module.exports = __webpack_public_path__ + "fonts/helveticaneue-webfont.192bbdf5.woff2";